module.exports = __webpack_public_path__ + "static/media/coin-music@2x.38486f5d.png";